import { Box, styled } from '@mui/material';

import { ColoredLineStyle } from './DoubleColorBackground.types';

export const DCBGContainer = styled(Box)(() => ({
  width: '100%',
  height: '100%',

  display: 'grid',
  gridTemplateRows: 'auto 1fr',

  position: 'absolute',
  zIndex: 0,
}));

export const ColoredLine = styled('div')(
  ({ highlight, colorHeight = 300 }: ColoredLineStyle) => ({
    width: '100%',
    height: `${colorHeight}px`,

    backgroundColor: highlight,

    '@media screen and (min-width: 1920px)': {
      height: `${colorHeight * 1.4}px`,
    },
  }),
);

export const TransparentLine = styled(Box)(() => ({
  width: '100%',
}));
